module.exports = window.i18next;